<template>
<form class="p-capture-form">
  <div class="p-capture-form__wrapper">
    <div>
      <dl class="p-capture-form__item">
        <dt class="p-capture-form__item-label">
          <Text className="c-text-s__bold" text="スクリーンショット（PC）"></Text>
          <Text className="c-text-s__error" v-show="error.imgPc.state" :text="error.imgPc.msg"></Text>
        </dt>
        <dd class="p-capture-form__item-input">
          <MyInput
            type="file"
            id="screen_pc"
            className="c-input__file"
            @change="handleFilePc"
            :fileName="displayFilenamePc">
          </MyInput>
        </dd>
      </dl>
      <dl class="p-capture-form__item mt15">
        <dt class="p-capture-form__item-label">
          <Text className="c-text-s__bold" text="スクリーンショット（スマホ）"></Text>
          <Text className="c-text-s__error" v-show="error.imgSp.state" :text="error.imgSp.msg"></Text>
        </dt>
        <dd class="p-capture-form__item-input">
          <MyInput
            type="file"
            id="screen_sp"
            className="c-input__file"
            @change="handleFileSp"
            :fileName="displayFilenameSp">
          </MyInput>
        </dd>
      </dl>
    </div>
    <dl class="p-capture-form__item">
      <dt class="p-capture-form__item-label">
        <Text className="c-text-s" text="背景色"></Text>
        </dt>
      <dd class="p-capture-form__item-input">
        <MyInput
          type="color"
          className="c-input__color"
          @change="handleBgColor"
          :value="bgColor">
        </MyInput>
      </dd>
    </dl>
  </div>
  <div class="p-capture-form__btn">
    <Button
      @click="capture"
      :className="['c-btn__primary--l-popup', 'gtm-generate-img', returnGenerateModeAsString, error.btn ? '--disabled' : '']"
      :disabled="error.btn"
      type="button"
      dataType="url"
      text="これでつくる！">
    </Button>
  </div>
</form>
</template>

<script>
import Store from '@/store/index.js'
import Text from '@/components/atoms/Text.vue'
import MyInput from '@/components/atoms/MyInput.vue'
import Button from '@/components/atoms/Button.vue'

export default {
  name: 'TabContentsCaptureImgForm',
  props: {
    fileNamePC: String,
    fileNameSP: String
  },
  data () {
    return {
      bgColor: Store.state.bgColor,
      error: {
        imgPc: {
          state: true,
          msg: null
        },
        imgSp: {
          state: true,
          msg: null
        },
        btn: true
      }
    }
  },
  components: {
    Text,
    MyInput,
    Button
  },
  computed: {
    displayFilenamePc () {
      let filename = String
      if (Store.state.file.pc) {
        filename = Store.state.file.pc.name
        if (filename.match(/\.(jpg|jpeg|png|)$/) === null) {
          this.handleImgError('pc', true)
        } else {
          this.handleImgError('pc', false)
        }
      } else {
        filename = ''
      }
      return filename
    },
    displayFilenameSp () {
      let filename = String
      if (Store.state.file.sp) {
        filename = Store.state.file.sp.name
        if (filename.match(/\.(jpg|jpeg|png|)$/) === null) {
          this.handleImgError('sp', true)
          this.handleBtnError()
        } else {
          this.handleImgError('sp', false)
          this.handleBtnError()
        }
      } else {
        filename = ''
      }
      return filename
    },
    returnGenerateModeAsString () {
      const bgColor = Store.state.bgColor
      let ptn = String
      Store.state.thumbnailType.p1 ? ptn = 'p1' : ptn = 'p2'
      return `${ptn}-${bgColor}`
    }
  },
  methods: {
    handleBgColor (e) {
      Store.commit('handleBgColor', e)
    },
    handleFilePc (e) {
      Store.commit('handleFilePc', e)
    },
    handleFileSp (e) {
      Store.commit('handleFileSp', e)
    },
    handleImgError (type, error) {
      let msg = String
      error ? msg = 'jpgかpngのファイルを選んでください' : msg = ''
      if (type === 'pc') {
        this.error.imgPc.state = error
        this.error.imgPc.msg = msg
      } else if (type === 'sp') {
        this.error.imgSp.state = error
        this.error.imgSp.msg = msg
      }
    },
    handleBtnError () {
      if (this.error.imgPc.state || this.error.imgSp.state) {
        this.error.btn = true
      } else {
        this.error.btn = false
      }
    },
    capture (e) {
      this.$emit('capture', e)
    }
  }
}

</script>

<style lang="scss" scoped>
.p-capture {
  &-form {
    &__wrapper {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      @include media-queries-sp {
        display: block;
      }
    }
    &__item {

      &-label {
        margin-bottom: 5px;
        padding-left: 15px;
        display: flex;
      }
      &-input {
      }
    }
    &__btn {
      margin-top: 30px;
    }
  }
}
</style>
